/**
 * 智能跳转工具函数
 * @param {string|object} to - 跳转目标 (路径字符串或路由对象)
 * @param {object} router - 当前项目的 router 实例
 * @param {boolean} isNewTab - 是否开启新窗口打开 (默认 false)
 */
export const smartPush = (to, router, opt) => {
  const { isNewTab = false } = opt || {};
  const B_PREFIX = '/cust';
  
  // 1. 解析目标路径和完整的 URL (带 query)
  let targetPath = '';
  let fullUrl = '';

  if (typeof to === 'string') {
    targetPath = to.split('?')[0];
    fullUrl = to;
  } else {
    targetPath = to.path || '';
    const queryString = to.query ? '?' + new URLSearchParams(to.query).toString() : '';
    fullUrl = targetPath + queryString;
  }

  // 2. 如果要求新窗口打开
  if (isNewTab) {
    // 无论是同项目还是跨项目，新窗口打开都只能用 window.open
    window.open(fullUrl, '_blank');
    return;
  }

  // 3. 当前窗口跳转逻辑
  const isTargetB = targetPath.startsWith(B_PREFIX);
  const isCurrentB = window.location.pathname.startsWith(B_PREFIX);

  if (isTargetB === isCurrentB) {
    // 同项目内：使用 vue-router 保持 SPA 体验
    router.push(to);
  } else {
    // 跨项目：使用原生跳转
    window.location.href = fullUrl;
  }
};